import { render, staticRenderFns } from "./handleDetails.vue?vue&type=template&id=7936a876&scoped=true&"
import script from "./handleDetails.vue?vue&type=script&lang=js&"
export * from "./handleDetails.vue?vue&type=script&lang=js&"
import style0 from "./handleDetails.vue?vue&type=style&index=0&id=7936a876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7936a876",
  null
  
)

export default component.exports